import { render, staticRenderFns } from "./LapidusClassSummary.vue?vue&type=template&id=9ae9aeae&"
import script from "./LapidusClassSummary.vue?vue&type=script&lang=js&"
export * from "./LapidusClassSummary.vue?vue&type=script&lang=js&"
import style0 from "./LapidusClassSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports